import React from "react";
import ClassicoHose from "../Garments/ClassicoHose";

export default function ClassicoHosePage() {
  return <ClassicoHose />;
}
